import { TemplateRequestPortal } from "components/templateRequests";

const TemplateRequestsApp = () => {
  return (
    <div className={"app"}>
      <TemplateRequestPortal />
    </div>
  );
};

export default TemplateRequestsApp;
